import React from "react";
import sopa from "../assets/sopa.webp";

const Navbar = () => {
  return (
    <div>
      <nav class="bg-[#222F52] border-gray-400 ">
        <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-5">
          <a class="flex items-center space-x-4 rtl:space-x-reverse">
            <img src={sopa} class="h-10" alt="GeeCom Logo" />
          </a>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
